import { GenialB2bPartnerPortalBFFWebApiDomainInterfacesRequestSortItem } from '@genial/services/dist/models';

import { TableHeadItemOrderBy } from '../components/TableHead';

export const transformSortItem = (
  orderBy?: TableHeadItemOrderBy
): GenialB2bPartnerPortalBFFWebApiDomainInterfacesRequestSortItem | undefined => {
  if (!orderBy) {
    return undefined;
  }
  return { sort: orderBy.value, sortDirection: orderBy.direction };
};
